export const initialState = {
	activeNavigation: 'Home',
};

export const whitelist = ['activeNavigation'];
